module.exports = __webpack_public_path__ + "img/3.05257bb7.jpg";